var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sf-footer"},[_c('div',{staticClass:"sf-footer__container",style:({ 'grid-template-columns': ' 1fr'.repeat(_vm.column) })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }